var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticStyle:{"margin-top":"100px"}},[_c('el-col',{attrs:{"sm":24,"lg":6}},[_c('el-result',{attrs:{"icon":"error","title":"扫码失败","subTitle":"点击左上角 x 号返回微信"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }